<template>
  <div class="home">
    <!-- <div><router-link to="/pc">1</router-link></div>

   <div><router-link to="/pc/sec">2</router-link></div>
    <router-view>

    </router-view>-->
    <Header></Header>

    <div>
      <Banner></Banner>

      <About></About>

      <Menu></Menu>

      <Gallery></Gallery>

      <Dinning></Dinning>

      <Contact></Contact>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Header from "../components/pc/header/Header2.vue";
import Banner from "../components/pc/banner/Banner.vue";
import About from "../components/pc/about/About4.vue";
import Menu from "../components/pc/menu/Menu.vue";
import Gallery from "../components/pc/gallery/Gallery2.vue";
import Dinning from "../components/pc/diningRoom/Dinning2.vue";
import Contact from "../components/pc/contact/Contact.vue";

export default {
  name: "Home",
  components: {
    Header,
    Banner,
    About,
    Menu,
    Gallery,
    Contact,
    Dinning
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.container {
  @media (max-width: 799px) {
    width: 95%;
    margin: 0 auto;
  }
}
</style>
